import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	length: '~4 years',
	timespan: 'Nov 2022 - Present,;June 2020 - May 2022',
	title: 'Senior Staff Software Engineer / Staff Software Engineer',
	technologies: ['Flask', 'Django', 'ReactJS', 'React Native', 'NodeJS', 'SQL (OLTP / OLAP)'],
	tools: ['SalesForce', 'GCP', 'MS Azure', 'Ansible', 'Docker', 'CircleCI', 'Terraform'],
	languages: ['JavaScript', 'Python', 'Typescript', 'Bash Scripting', 'Kotlin', 'Swift', 'Apex'],
	company: 'The Helper Bees',
	description: 'A company that provides seniors with tools to help them age-in-place',
	location: 'Austin, Texas (Remote)',
	results: 'Feb 2025 - 35M Series C raise',
	details: [
		{
			showMeOn: ['regulated'],
			autonomous: false,
			// entry: 'Improved Ops Team throughput by 50% by spearheading a UX redesign of Ops tool suite',
			entry: 'Managed and worked with highly regulated healthcare data (subjected to HIPAA)',
		},
		{
			showMeOn: ['all'],
			autonomous: false,
			// entry: 'Improved Ops Team throughput by 50% by spearheading a UX redesign of Ops tool suite',
			entry: 'Set architectural direction for a 15-engineer org; unified fragmented frontends and services under a coherent interface and shared data model, enabling faster iteration and system-wide observability',
		},
		{
			showMeOn: ['all'],
			autonomous: true,
			// entry: 'Improved Ops Team throughput by 50% by spearheading a UX redesign of Ops tool suite',
			entry: 'Improved company-wide visibility over KPIs by designing, architecting, and implementing a real-time dashboard backed by Google BigQuery and a GCP-hosted microservice',
		},
		{
			showMeOn: ['all'],
			autonomous: true,
			// entry: 'Improved Ops Team throughput by 50% by spearheading a UX redesign of Ops tool suite',
			entry: 'Improved Ops Team throughput by 50% by redesigning Operations tool suite with a focus on usability and UX',
		},
		{
			autonomous: true,
			showMeOn: ['all'],

			entry: 'Increased software team efficiency by 75% by refactoring the monolith for modularity and Developer Experience',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Reduced partner onboarding time from 2 weeks to 30 minutes by automating the onboarding process',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Cut firefighting efforts by 90% by introducing a Slack bot that surfaced historical communication context on demand',
		},
		{
			showMeOn: ['all'],
			entry: 'Enabled scalable partner onboarding by migrating pipeline to Salesforce, replacing manual flow with automated architecture',
		},
		{
			showMeOn: ['all'],
			entry: 'Improved team throughput and delivery predictability by leading sprint planning and retrospectives',
		},
		{
			showMeOn: ['all'],
			// entry: "Mentored developers, improving team performance and code quality",
			// entry: "Mentored developers, fostering a culture of learning and code quality,",
			entry: 'Improved team efficiency and collaboration by mentoring engineers and cultivating a learning-driven engineering culture',
		},
	],
};
